import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Card,
  CardContent,
  useTheme
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// News data - in a real app, this would come from an API
const newsArticles = [
  {
    id: 'union-negotiations',
    title: 'Union Negotiations Progress',
    date: 'March 15, 2024',
    description: 'Significant progress made in negotiations for better working conditions and fair compensation for teachers across the district.',
    gradient: 'linear-gradient(45deg, #2e7d32 30%, #81c784 90%)'
  },
  {
    id: 'community-outreach',
    title: 'Community Outreach Success',
    date: 'March 10, 2024',
    description: 'Our campaign\'s community outreach program has successfully engaged with over 500 local residents, building strong support for education reform.',
    gradient: 'linear-gradient(45deg, #f9a825 30%, #ffd54f 90%)'
  },
  {
    id: 'teacher-workshop',
    title: 'Teacher Workshop Series',
    date: 'March 5, 2024',
    description: 'Launching a new series of professional development workshops to support teachers in implementing innovative teaching methods.',
    gradient: 'linear-gradient(45deg, #2e7d32 30%, #81c784 90%)'
  },
  {
    id: 'education-summit',
    title: 'Education Summit Success',
    date: 'February 28, 2024',
    description: 'Hosted a successful education summit bringing together teachers, administrators, and community leaders to discuss education reform.',
    gradient: 'linear-gradient(45deg, #f9a825 30%, #ffd54f 90%)'
  }
];

function News() {
  const theme = useTheme();

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography 
        variant="h3" 
        component="h1" 
        gutterBottom 
        fontWeight="bold"
        sx={{ mb: 4 }}
      >
        Latest News
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -2 }}>
        {newsArticles.map((article) => (
          <Box 
            key={article.id}
            sx={{ 
              width: { xs: '100%', sm: '50%' },
              p: 2
            }}
          >
            <Card 
              component={RouterLink} 
              to={`/news/${article.id}`}
              sx={{ 
                height: '100%',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: 6,
                }
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: 200,
                  background: article.gradient,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '2rem',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  p: 2,
                }}
              >
                {article.title}
              </Box>
              <CardContent>
                <Typography 
                  variant="subtitle2" 
                  color="text.secondary" 
                  gutterBottom
                >
                  {article.date}
                </Typography>
                <Typography 
                  variant="body1" 
                  color="text.primary"
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {article.description}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>
    </Container>
  );
}

export default News; 